import styled from "styled-components";

const Searchbar = styled.input`
  background-color: white;
  border: 1px solid #afafaf;
  border-radius: 2vw;
  width: 80%;
  font-size: 0.8em;
  padding: 1vw;
  color: black;

  @media (orientation: landscape) {
    width: 30vw;
    min-width: 300px;
  }
`;

export default Searchbar;
